import { useState, useRef, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { ChevronDown, Search, X } from "lucide-react";

const SearchableSelect = ({ value, onChange, options, placeholder, testId }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );

  const selected = options.find(o => o.value === value);

  return (
    <div className="relative" ref={ref} data-testid={testId}>
      <button
        type="button"
        className="flex h-9 w-full items-center justify-between rounded-sm border border-border bg-input px-3 py-2 text-sm text-foreground"
        onClick={() => setOpen(!open)}
      >
        <span className={selected ? "text-foreground" : "text-muted-foreground"}>
          {selected ? selected.label : placeholder || "Select..."}
        </span>
        <ChevronDown className="w-3.5 h-3.5 text-muted-foreground" />
      </button>
      {open && (
        <div className="absolute top-full left-0 right-0 z-50 mt-1 bg-popover border border-border rounded-sm shadow-lg overflow-hidden">
          <div className="p-1.5 border-b border-border">
            <div className="relative">
              <Search className="absolute left-2 top-1/2 -translate-y-1/2 w-3 h-3 text-muted-foreground" />
              <Input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search..."
                className="h-7 pl-6 text-xs bg-input border-border rounded-sm"
                autoFocus
                data-testid={`${testId}-search`}
              />
            </div>
          </div>
          <div className="max-h-48 overflow-y-auto p-1">
            <button
              type="button"
              className="block w-full text-left text-xs px-2 py-1.5 hover:bg-muted/50 text-muted-foreground rounded-sm"
              onClick={() => { onChange(""); setOpen(false); setSearch(""); }}
            >
              None
            </button>
            {filtered.map(o => (
              <button
                key={o.value}
                type="button"
                className={`block w-full text-left text-xs px-2 py-1.5 hover:bg-muted/50 rounded-sm ${value === o.value ? "text-primary font-medium" : "text-foreground"}`}
                onClick={() => { onChange(o.value); setOpen(false); setSearch(""); }}
              >
                {o.label}
              </button>
            ))}
            {filtered.length === 0 && (
              <p className="text-xs text-muted-foreground px-2 py-2">No results</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
